// Create an HTTP interceptor
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (
            event instanceof HttpResponse &&
            event.body &&
            event.body.data
          ) {
            return event;
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error.message);
        return throwError(() => error);
      })
    );
  }
}
